<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-wallet icon"></i>
        <span>Financeiro</span>
      </h1>
    </div>
  </div>


  <div v-if="!loading || payments.data.length" class="align p-4 space_title">
    <div class="card mb-4">
      <div id="balance" class="d-flex align-items-center p-4">
        <div class="item">
          <p class="mb-0">Saldo disponível</p>
          <h5 class="mb-0">{{ $moneyFormat(payments.balance) }}</h5>
        </div>

        <div class="item ms-auto">
          <PrimaryButton @click="requestPayment" v-if="payments.balance" class="px-5">
            Solicitar saque
          </PrimaryButton>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="table_container">
      <table>
        <thead>
          <tr>
            <th>Data</th>
            <th>Valor</th>
            <th>Status</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(payment, key) in payments.data" :key="key">
            <td>
              {{ $dateFormat(payment.created_at) }}
            </td>
            <td>
              {{ $moneyFormat(payment.amount) }}
            </td>
            <td>
              <span class="badge" :style="'background-color: ' + payment.status_color">{{ payment.status_name }}</span>
            </td>
            <td class="actions">
              <router-link :to="{ name: 'payment', params: { id: payment.id } }">
                <button class="btn btn-secondary">
                  <i class="fa-regular fa-eye"></i>
                </button>
              </router-link>
            </td>
          </tr>
          <tr class="no_result" v-if="payments.data && !payments.data.length">
            <td colspan="10">
              Nenhum resultado encontrado
            </td>
          </tr>
        </tbody>
      </table>
      </div>
    </div>

    <ListPagination class="mt-4" :links="payments.links" />
  </div>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import { onBeforeMount, ref, watch } from 'vue';
import { usePaymentStore } from '@/stores/PaymentStore'
import { storeToRefs } from 'pinia';
import ListPagination from '@/components/ListPagination.vue'
import { inject } from 'vue';
import { useRoute } from 'vue-router';
import { useToast, TYPE } from "vue-toastification"

const loader = inject('$loader');
const toast = useToast();

const route = useRoute();
const paymentStore = usePaymentStore();
const { payments, filter } = storeToRefs(paymentStore);

const loading = ref(false);

onBeforeMount(() => {
  loadPayments();
});

watch(() => route.query.payment, (newPayment, oldPayment) => {
  if (newPayment !== oldPayment) {
    window.scrollTo(0, 0);
    loadPayments();
  }
});

async function loadPayments() {
  loader.show();
  loading.value = true;

  filter.value.payment = parseInt(route.query.payment);
  filter.value.limit = 10;

  await paymentStore.getPayments();
  loader.hide();
  loading.value = false;
}

async function requestPayment(){
  loader.show();
  if(loading.value == true){
    return;
  }

  loading.value = true;
  const formResult = await paymentStore.addPayment();

  if(formResult.success){
    toast('Saque solicitado', { type: TYPE.SUCCESS, timeout: 6000 });
    loadPayments();
  }else if(formResult.message){
    toast(formResult.message, { type: TYPE.ERROR, timeout: 6000 });
  }
  
  loader.hide();
  loading.value = false;
}
</script>

<style scoped>
@media screen and (max-width: 768px){
  #balance {
    display: block !important;
    text-align: center;
  }

  #balance button {
    margin-top: 20px;
    width: 100%;
  }
}
</style>